export const apiAuthorizationConfig = {
    endpoint: '/',
    applicationName: 'EsituDrive',
};